/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerIntegrationApiUserDto } from '../models/EntityModelResponseContainerIntegrationApiUserDto';
import type { IntegrationApiUserDto } from '../models/IntegrationApiUserDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemIntegrationApiUserControllerService {
    /**
     * @returns EntityModelResponseContainerIntegrationApiUserDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: IntegrationApiUserDto,
    }): CancelablePromise<EntityModelResponseContainerIntegrationApiUserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/integrationapiusers',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        programId,
    }: {
        programId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/integrationapiusers/{programId}',
            path: {
                'programId': programId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerIntegrationApiUserDto OK
     * @throws ApiError
     */
    public static read({
        programId,
    }: {
        programId: number,
    }): CancelablePromise<EntityModelResponseContainerIntegrationApiUserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/integrationapiusers/{programId}',
            path: {
                'programId': programId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerIntegrationApiUserDto OK
     * @throws ApiError
     */
    public static update({
        programId,
        requestBody,
    }: {
        programId: number,
        requestBody: IntegrationApiUserDto,
    }): CancelablePromise<EntityModelResponseContainerIntegrationApiUserDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/integrationapiusers/{programId}',
            path: {
                'programId': programId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
